import loadable from '@loadable/component';

export const LazyContactCollectorGuest = loadable(() => import(/* webpackChunkName: "content/contactCollector/guest" */ '.'));
